import {any, isEmpty, isNil, merge} from 'ramda';
import {retrieveUser} from '../api'; // eslint-disable-line import/no-cycle

const KEY = `swill-${process.env.NODE_ENV}`;

const saveUser = user => {
  localStorage.setItem(KEY, JSON.stringify(user));
};

const loadUser = () => {
  const stringUser = localStorage.getItem(KEY);
  return isNil(stringUser) ? null : JSON.parse(stringUser);
};

const patchUser = newUser => {
  const oldUser = loadUser();
  if (isNil(oldUser)) {
    saveUser(newUser);
  } else {
    const newUserWithToken = merge(oldUser, newUser);
    saveUser(newUserWithToken);
  }
};

/*
  Refreshes the cached User object in local storage, while persisting the existing token to ensure the user does
  not get logged out.
 */
const refresh = () => {
  const oldUser = loadUser();
  return retrieveUser(oldUser.id)
    .then(response => {
      const newUser = response.data;

      // Merges user with oldUser to ensure our authentication token does not get deleted from local storage
      const newUserWithToken = merge(oldUser, newUser);

      saveUser(newUserWithToken);
      return newUser;
    });
};

const getUserProperty = (propertyKey) => {
  const user = loadUser();
  return isNil(user) ? null : user[propertyKey];
};

const getUserPropertyWithRefresh = (propertyKey) => {
  const user = loadUser();
  if (isNil(user) || isNil(user[propertyKey])) {
    return refresh()
      .then(newUser => newUser[propertyKey]);
  } else {
    return Promise.resolve(user[propertyKey]);
  }
};

const getUserSchoolRoles = () => {
  const user = loadUser();
  if (isNil(user)) {
    return [];
  }

  // If there are no user_school_roles then this is an old session and we need to reload the user
  if (isNil(user.user_school_roles) || isEmpty(user.user_school_roles)) {
    return refresh()
      .then(newUser => newUser.user_school_roles);
  } else {
    return user.user_school_roles;
  }
};

const userHasRole = (roleName) => any(usr => usr.role.name === roleName, getUserSchoolRoles());

const getSchoolProperty = (propertyKey) => {
  const user = loadUser();
  return isNil(user) || isNil(user.school) ? null : user.school[propertyKey];
};

const clear = () => localStorage.removeItem(KEY);

const isAuthenticated = () => {
  const user = loadUser();
  return !isNil(user) && !isNil(user.token);
};

const isOwesTeamMoney = () => {
  const user = loadUser();
  return !isNil(user) && user.needs_team_payment;
};

const isOwesSubscriptionMoney = () => {
  const user = loadUser();
  return !isNil(user) && user.needs_subscription_payment;
};

const madeTeamPayment = () => refresh();

const madeSubscriptionPayment = () => refresh();

export {
  saveUser,
  loadUser,
  patchUser,
  clear,
  isAuthenticated,
  isOwesTeamMoney,
  isOwesSubscriptionMoney,
  getUserProperty,
  getUserPropertyWithRefresh,
  getUserSchoolRoles,
  userHasRole,
  getSchoolProperty,
  madeTeamPayment,
  madeSubscriptionPayment
};



// WEBPACK FOOTER //
// ./src/util/Session.js